// Centralized paging and limit constants for Firestore queries and infinite scroll.
// Keeping these in one place makes it easier to tune production behavior.

export const PAGING = {
  // Generic defaults
  DEFAULT_PAGE_SIZE: 20,

  // Public art history grid
  ART_HISTORY_PUBLIC_PAGE_SIZE: 20,

  // Public submissions loaded in carousels/modals per activity
  PUBLIC_SUBMISSIONS_PER_ACTIVITY_LIMIT: 50,

  // Recent window for per-user history listeners (art history, etc.)
  USER_HISTORY_RECENT_LIMIT: 200,

  // Page size when paging through older user history (beyond realtime window)
  USER_HISTORY_OLDER_PAGE_SIZE: 50,

  // Initial batch size for lazily resolving like state in carousels
  INITIAL_LIKE_BATCH: 10,
};

